module.exports = __webpack_public_path__ + "static/img/born to play.9dfee4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/born to play.png
// module id = FhmT
// module chunks = 12